import { render, staticRenderFns } from "./fileList.vue?vue&type=template&id=b48ce204"
import script from "./fileList.vue?vue&type=script&lang=js"
export * from "./fileList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b48ce204')) {
      api.createRecord('b48ce204', component.options)
    } else {
      api.reload('b48ce204', component.options)
    }
    module.hot.accept("./fileList.vue?vue&type=template&id=b48ce204", function () {
      api.rerender('b48ce204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/fileList.vue"
export default component.exports